// Public destinations only. Never append account, essay, page-query or Beta-ID data.
export const BETA_SURVEYS = Object.freeze([
    Object.freeze({ id: 'mid', title: 'Mid-trial check-in', detail: 'Optional · about 45 seconds', url: 'https://forms.gle/erK4RvkC5Y6irqrB8' }),
    Object.freeze({ id: 'end', title: 'End-of-trial feedback', detail: 'About 2–3 minutes', url: 'https://forms.gle/a6aR5RmrRLxzz4iq5' }),
]);

function normalizeContact(link) {
    if (!link || typeof link.url !== 'string' || /[\r\n]/.test(link.url)) return null;
    try {
        const url = new URL(link.url);
        if (url.protocol === 'mailto:') {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(url.pathname) || url.search || url.hash || /%0[ad]/i.test(url.href)) return null;
        } else if (url.protocol !== 'https:' || url.username || url.password) return null;
        const text = (value, fallback) => typeof value === 'string' && value.trim() ? value.trim().slice(0, 100) : fallback;
        return { url: url.href, external: url.protocol === 'https:', label: text(link.label, 'Contact us'), display: text(link.display, text(link.label, 'Contact us')) };
    } catch { return null; }
}

export function helpContacts(configured, fallback = []) {
    const clean = values => {
        const seen = new Set();
        return (Array.isArray(values) ? values : []).map(normalizeContact).filter(link => {
            if (!link || seen.has(link.url)) return false;
            seen.add(link.url);
            return true;
        }).slice(0, 4);
    };
    const selected = clean(configured);
    return selected.length ? selected : clean(fallback);
}
